export default function Footer({ t }) {
  return (
    <footer
      data-testid="footer"
      className="bg-bn-secondary text-bn-bg/80 py-12 border-t-4 border-bn-primary"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid md:grid-cols-3 gap-8 mb-10">
          <div>
            <div className="flex items-center gap-2 mb-3">
              <div className="bg-bn-primary text-bn-bg px-3 py-1.5 font-display text-lg leading-none">
                BODEGÓN
              </div>
              <div className="font-display text-bn-bg text-lg leading-none">NÚÑEZ</div>
            </div>
            <p className="font-body text-sm text-bn-bg/60">{t.footer.tagline}</p>
            <p className="font-script text-xl text-bn-accent mt-3">— el más grande —</p>
          </div>

          <div>
            <h4 className="font-display text-bn-bg text-base mb-3 uppercase tracking-wider">Palermo</h4>
            <p className="font-body text-sm text-bn-bg/70">
              José A. Cabrera 4667
              <br />
              C1414 CABA
            </p>
          </div>

          <div>
            <h4 className="font-display text-bn-bg text-base mb-3 uppercase tracking-wider">Núñez</h4>
            <p className="font-body text-sm text-bn-bg/70">
              Arribeños 3198
              <br />
              C1429 CABA
            </p>
          </div>
        </div>

        <div className="pt-6 border-t border-bn-bg/20 flex flex-col md:flex-row justify-between items-center gap-3">
          <p className="font-body text-xs text-bn-bg/50">
            © {new Date().getFullYear()} Bodegón Núñez. {t.footer.rights}
          </p>
          <p className="font-script text-base text-bn-bg/60">{t.footer.built}</p>
        </div>
      </div>
    </footer>
  );
}
